module.exports = __webpack_public_path__ + "static/media/analog.741de8d5.png";